import { render, staticRenderFns } from "./webSign.vue?vue&type=template&id=16a57b92&scoped=true"
import script from "./webSign.vue?vue&type=script&lang=js"
export * from "./webSign.vue?vue&type=script&lang=js"
import style0 from "./webSign.vue?vue&type=style&index=0&id=16a57b92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a57b92",
  null
  
)

export default component.exports